import { render } from "./Index.vue?vue&type=template&id=5ef72976&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5ef72976"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ef72976')) {
    api.reload('5ef72976', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5ef72976&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}", () => {
    api.rerender('5ef72976', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Sessions/Index.vue"

export default script